(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('MateriaDialogController', MateriaDialogController);

    MateriaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Materia', 'Norma'];

    function MateriaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Materia, Norma) {
        var vm = this;

        vm.materia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.materia.id !== null) {
                Materia.update(vm.materia, onSaveSuccess, onSaveError);
            } else {
                Materia.save(vm.materia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:materiaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
